var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _linearGradient, _path30, _linearGradient2, _path31, _linearGradient3, _path32, _path33, _path34, _path35, _linearGradient4, _path36, _path37;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOutlookIntegrationIcon = function SvgOutlookIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#103262",
    d: "m43.255 23.547-6.81-3.967v11.594H44v-6.331a1.5 1.5 0 0 0-.745-1.296z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0084d7",
    d: "M13 10h10v9H13v-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33afec",
    d: "M23 10h10v9H23v-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#54daff",
    d: "M33 10h10v9H33v-9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#027ad4",
    d: "M23 19h10v9H23v-9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0553a4",
    d: "M23 28h10v9H23v-9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#25a2e5",
    d: "M33 19h10v9H33v-9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0262b8",
    d: "M33 28h10v9H33v-9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.019,
    d: "M13 37h30V24.238l-14.01 8-15.99-8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.038,
    d: "M13 37h30V24.476l-14.01 8-15.99-8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.057,
    d: "M13 37h30V24.714l-14.01 8-15.99-8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.076,
    d: "M13 37h30V24.952l-14.01 8-15.99-8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.095,
    d: "M13 37h30V25.19l-14.01 8-15.99-8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.114,
    d: "M13 37h30V25.429l-14.01 8-15.99-8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.133,
    d: "M13 37h30V25.667l-14.01 8-15.99-8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.152,
    d: "M13 37h30V25.905l-14.01 8-15.99-8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.171,
    d: "M13 37h30V26.143l-14.01 8-15.99-8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.191,
    d: "M13 37h30V26.381l-14.01 8-15.99-8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.209,
    d: "M13 37h30V26.619l-14.01 8-15.99-8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229,
    d: "M13 37h30V26.857l-14.01 8-15.99-8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.248,
    d: "M13 37h30v-9.905l-14.01 8-15.99-8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.267,
    d: "M13 37h30v-9.667l-14.01 8-15.99-8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    d: "M13 37h30v-9.429l-14.01 8-15.99-8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.305,
    d: "M13 37h30v-9.19l-14.01 8-15.99-8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.324,
    d: "M13 37h30v-8.952l-14.01 8-15.99-8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.343,
    d: "M13 37h30v-8.714l-14.01 8-15.99-8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.362,
    d: "M13 37h30v-8.476l-14.01 8-15.99-8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M13 37h30v-8.238l-14.01 8-15.99-8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 37h30v-8l-14.01 8L13 29z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook-integration-icon_svg__a",
    x1: 38.925,
    x2: 32.286,
    y1: 24.557,
    y2: 36.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31abec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1582d5"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#outlook-integration-icon_svg__a)",
    d: "M15.441 42h26.563a1.996 1.996 0 0 0 2-1.994C44.007 35.485 44 24.843 44 24.843s-.007.222-1.751 1.212-27.505 15.511-27.505 15.511.234.434.697.434z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook-integration-icon_svg__b",
    x1: 13.665,
    x2: 41.285,
    y1: 6.992,
    y2: 9.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#076db4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0461af"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#outlook-integration-icon_svg__b)",
    d: "M43 10H13V8a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v2z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook-integration-icon_svg__c",
    x1: 28.153,
    x2: 23.638,
    y1: 33.218,
    y2: 41.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33acee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8edf"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#outlook-integration-icon_svg__c)",
    d: "M13 25v15a2 2 0 0 0 2 2H42.004a1.98 1.98 0 0 0 1.221-.425L13 25z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.319 13H13v24h8.319A3.68 3.68 0 0 0 25 33.319V16.681A3.68 3.68 0 0 0 21.319 13z",
    opacity: 0.05
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.213 36H13V13.333h8.213a3.12 3.12 0 0 1 3.121 3.121v16.425A3.122 3.122 0 0 1 21.213 36z",
    opacity: 0.07
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.106 35H13V13.667h8.106a2.56 2.56 0 0 1 2.56 2.56V32.44a2.56 2.56 0 0 1-2.56 2.56z",
    opacity: 0.09
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook-integration-icon_svg__d",
    x1: 3.53,
    x2: 22.41,
    y1: 14.53,
    y2: 33.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1784d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0864c5"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#outlook-integration-icon_svg__d)",
    d: "M21 34H5a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 18.691c-3.111 0-4.985 2.377-4.985 5.309S9.882 29.309 13 29.309c3.119 0 4.985-2.377 4.985-5.308 0-2.933-1.874-5.31-4.985-5.31zm0 8.826c-1.765 0-2.82-1.574-2.82-3.516s1.06-3.516 2.82-3.516 2.821 1.575 2.821 3.516-1.057 3.516-2.821 3.516z"
  })));
};

export default SvgOutlookIntegrationIcon;